import { Injectable } from '@angular/core';
import { EntityManager } from '@proximus/entity-manager';
import { NortonAccountRegistrationEntity } from '../configs/entity.config';

@Injectable({
  providedIn: 'root',
})
export class NortonService {
  constructor() {}

  getNortonAccountInfo(payload: any) {
    const value = {
      ssids: payload.ssids,
    };
    const iEntity = EntityManager.createEntity(
      NortonAccountRegistrationEntity,
      {},
    );
    iEntity.value = value;
    return EntityManager.saveEntity(iEntity);
  }
}
